import { Text, Group, ActionIcon, Tooltip } from '@mantine/core';
import { IconUrgent, IconLogout, IconUserFilled, IconSparkles } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import classes from './menu.module.css';
import { useAutenticacion } from '../../contextos/authContext';
import { useAsistenteIA } from '../../contextos/asistenteIAContext';
import ModalTareaCV from '../../../modulos/Tareas/controladorVista/modalTareaCV';
import { useState } from 'react';
import { estadoInicialTarea } from '../../../modulos/Tareas/interfaces';
import type { ITareaFormulario } from '../../../modulos/Tareas/interfaces/ITareaFormulario';
import { usePermisos } from '../../contextos/usePermisos';
import { EnumPermisos } from '../../enums/enumPermisos';
import { CampanaNotificacionesCV } from '../notificaciones/campanaNotificacionesCV';

export const MenuBarra = () => {
    const { usuario, cerrarSesion, estaAutenticado } = useAutenticacion();
    const { alternarDrawer, drawerAbierto } = useAsistenteIA();
    const { tienePermiso } = usePermisos();
    const navigate = useNavigate();
    const [estadoModal, setEstadoModal] = useState<boolean>(false);
    const [entidadTarea, setEntidadTarea] = useState<ITareaFormulario>(estadoInicialTarea);
    // Notificaciones: cada origen decide por rol (p. ej. mantenimiento a costo, solo Analista); sin ninguno, no se muestra.
    const codigosRol = usuario?.Rol?.map(r => r.Id) ?? [];

    const manejarCerrarSesion = () => {
        cerrarSesion();
        navigate('/ingresar');
    };

    if (!estaAutenticado) {
        return null;
    }

    return (
        <>
            <header className={classes.headerMenuBarra}>
                <div className={classes.inner} style={{ height: '56px' }}>
                    {/* Logo: Se oculta en móvil por CSS */}
                    <Group className={classes.logoHeader}>
                        <img src="/logo-conekta-smart-02.png" width={95} alt="Logo" />
                    </Group>

                    {/* Contenedor de acciones: Cambia a space-between en móvil */}
                    <div className={classes.accionesWrapper}>

                        {/* 1. Icono de Alerta (Quedará a la izquierda en móvil). La emergencia es una tarea SER,
                            por eso requiere el permiso de asignar técnicos SER (no aplica a Planeador ni Calidad) */}
                        {tienePermiso(EnumPermisos.PERMISO_TAREAS_ASIGNAR_TECNICO) && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Tooltip label="Emergencia" withinPortal zIndex={9999}>
                                    <ActionIcon
                                        variant="filled"
                                        radius="xl"
                                        size="lg"
                                        onClick={() => setEstadoModal(true)}
                                        style={{ backgroundColor: '#d7263d', boxShadow: '0 4px 12px rgba(215, 38, 61, 0.4)' }}
                                    >
                                        <IconUrgent color="white" size={20} />
                                    </ActionIcon>
                                </Tooltip>
                            </div>
                        )}

                        {/* 2. Grupo de Asistente de IA, Usuario y Logout (Quedarán juntos a la derecha en móvil) */}
                        <Group gap="md">
                            <CampanaNotificacionesCV codigosRol={codigosRol} />

                            {/* 1.5 Icono de Asistente de IA (Visible según permiso de BD) */}
                            {tienePermiso(EnumPermisos.PERMISO_ASISTENTE_IA_VER) && (
                                <Tooltip label="Asistente de IA" withinPortal zIndex={9999}>
                                    <ActionIcon
                                        variant="subtle"
                                        color="white"
                                        radius="xl"
                                        size="lg"
                                        onClick={alternarDrawer}
                                        style={{ 
                                            backgroundColor: drawerAbierto ? 'rgba(255, 255, 255, 0.15)' : undefined,
                                            transition: 'all 0.2s ease'
                                        }}
                                    >
                                        {/* Elegimos IconSparkles porque los destellos representan la inteligencia artificial,
                                            brindando una sensación moderna y mágica, consistente con los patrones UX actuales (como Google Gemini). */}
                                        <IconSparkles size={20} />
                                    </ActionIcon>
                                </Tooltip>
                            )}

                            <Group gap={8}>
                                <IconUserFilled color="white" size={16} />
                                <Text fz={13} c="#fff" fw={600} className={classes.userNameMobile}>{usuario?.NombreCompleto}</Text>
                            </Group>

                            <Tooltip label="Cerrar sesión" withinPortal zIndex={9999}>
                                <ActionIcon
                                    variant="subtle"
                                    color="white"
                                    radius="xl"
                                    size="lg"
                                    onClick={manejarCerrarSesion}
                                >
                                    <IconLogout size={20} />
                                </ActionIcon>
                            </Tooltip>
                        </Group>
                    </div>
                </div>
                {estadoModal && (
                    <ModalTareaCV
                        consultarTareas={() => { }}
                        abrirModalTarea={setEstadoModal}
                        estadoModal={estadoModal}
                        entidadTarea={entidadTarea}
                        setEntidadTarea={setEntidadTarea}
                        esEmergencia={true}
                        visualizacion={false}
                    />
                )}
            </header>

        </>
    );
};
